// Maison Bundle — cart rounding fix
// The bundle rounds each tier's per-bottle price DOWN to whole cents, losing up to
// 1 cent per bottle versus how Shopify + Juo round the stacked Subscribe & Save
// discount — so the cart total ends up a few cents above the page total.
// This wraps the global maisonBundle() factory and adds a small per-bottle
// correction so the per-bottle price, the tier total and the ADD TO CART price all
// match the cart. 1 cent per bottle => 3-bottle tier +3c, 4-bottle tier +4c, etc.
//
// Scope: ONLY the 2nd and 3rd displayed cards (index 1 and 2) in subscribe mode.
// The 1st/top card is left untouched (it matches the cart already), and so are the
// BOGO tier and one-time pricing.
(function () {
  var PER_BOTTLE_CENTS = 1; // override with window.MAISON_ROUND_FIX_CENTS

  function wrap() {
    if (typeof window.maisonBundle !== 'function' || window.maisonBundle.__roundfix) return;
    var _orig = window.maisonBundle;
    var wrapped = function () {
      var obj = _orig();
      var _currentPrice = obj.currentPrice;
      obj.currentPrice = function (tier) {
        var p = _currentPrice.call(this, tier);
        var add = (window.MAISON_ROUND_FIX_CENTS != null) ? window.MAISON_ROUND_FIX_CENTS : PER_BOTTLE_CENTS;
        var idx = this.allTiers ? this.allTiers.indexOf(tier) : -1;
        if (add && idx >= 1 && tier && tier.oneTimeSave > 0 && this.subscribeOn) {
          p += add;
        }
        return p;
      };
      return obj;
    };
    wrapped.__roundfix = true;
    window.maisonBundle = wrapped;
  }

  wrap();
  document.addEventListener('alpine:init', wrap);
})();
